import './footer.css'

import NavMenu from '../NavMenu/NavMenu';
import SocialLinks from '../SocialLinks/SocialLinks';

export default function Footer() {
    return (
        <footer>
            <div className="inner">
                <div className="cols span-2">
                    <div className="col">
                        <a href="/" className="logo"><img src="/logo.jpeg" alt="Logo" /></a>
                        <p>Copyright &copy; {new Date().getFullYear()}</p>
                        <p className="watermark">Made by <a href="https://www.callum-tanner.com">Callum Tanner</a></p>
                    </div>
                    <div className="col">
                        <NavMenu />
                        <hr />
                        <ul className="nav-menu">
                            <SocialLinks />
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}